import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";
import {IOfferModalPropertyListType} from "../types/OfferModalPropertyListType";

const getCustomLabel = (listType: IOfferModalPropertyListType | "property") => {
    switch (listType) {
        case "tiles":
            return "rzuty";
        case "table":
            return "lista";
        case "property":
            return "nieruchomość";
        default:
            return "";
    }
};

export const hitOfferModalArrowGtm = (direction: "left" | "right", listType: IOfferModalPropertyListType | "property") => {
    const customLabel = getCustomLabel(listType);

    hitGoogleTagManager({
        event: "offer_modal_arrow",
        event_action: "click",
        event_label: direction,
        custom_label: customLabel
    });
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";
import {IOfferModalPropertyListType} from "../types/OfferModalPropertyListType";

const getCustomLabel = (listType: IOfferModalPropertyListType | "property") => {
    switch (listType) {
        case "tiles":
            return "rzuty";
        case "table":
            return "lista";
        case "property":
            return "nieruchomość";
        default:
            return "";
    }
};

export const hitOfferModalArrowGtm = (direction: "left" | "right", listType: IOfferModalPropertyListType | "property") => {
    const customLabel = getCustomLabel(listType);

    hitGoogleTagManager({
        event: "offer_modal_arrow",
        event_action: "click",
        event_label: direction,
        custom_label: customLabel
    });
};
